export default __webpack_public_path__ + "static/media/p.15b6c927.png";